import { render, staticRenderFns } from "./ReadingLog.vue?vue&type=template&id=0652e081&"
import script from "./ReadingLog.vue?vue&type=script&lang=js&"
export * from "./ReadingLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports